// extracted by mini-css-extract-plugin
module.exports = {"seriesListWrapper":"um","fullWidth":"un","seriesListTabWrapper":"uo","tab":"up","active":"uq"};